import { useState } from 'react';
import { useDispatch, useSelector } from 'react-redux';
import { Container, Modal } from '@mui/material';
import dayjs from 'dayjs';
import { Formik } from 'formik';

import { CONSTANTS, STRINGS } from 'src/commons';
import { loaderReducerAction } from 'src/redux/reducers/loader';
import { commonReducerAction } from 'src/redux/reducers/common';
import PaymentForm from 'src/components/payments/PaymentFrom';
import { addPayment, getPayment } from 'src/api/payment';
import { paymentReducerAction } from 'src/redux/reducers/payment';

const RegisterPaymentModal = ({ open, setOpen, member }) => {
  const date = dayjs();
  const { startLoading, stopLoading } = loaderReducerAction;
  const dispatch = useDispatch();
  const { logoutUser } = commonReducerAction;
  const { updatePayments } = paymentReducerAction;
  const { user } = useSelector((state) => state.common);
  const [snackbarState, setSnackbarState] = useState({
    open: false,
    message: '',
    severity: ''
  });
  const handleClose = (event, reason) => {
    if (reason === 'clickaway') {
      return;
    }

    setSnackbarState({
      ...snackbarState,
      open: false
    });
  };

  return (
    <>
      <Modal
        maxWidth="sm"
        sx={{ overflow: 'scroll', padding: '1rem' }}
        open={open}
        onClose={setOpen}
      >
        <Container
          maxWidth="sm"
          sx={{
            padding: '.8rem',
            backgroundColor: 'background.default',
            borderRadius: '10px'
          }}
        >
          <Formik
            initialValues={{
              amount: '',
              payment_for_this_month: dayjs(date).format('YYYY-MM-DD'),
              payment_received_on: '',
              mode_of_payment: 0
            }}
            validationSchema={CONSTANTS.registerPaymentScheme}
            onSubmit={async (values) => {
              const result = {
                member_id: member._id,
                amount: values.amount,
                date: dayjs(values.payment_received_on).valueOf(),
                payment_month_year: dayjs(values.payment_for_this_month).format(
                  'MM-YYYY'
                ),
                mode_of_payment: values.mode_of_payment
              };

              try {
                dispatch(startLoading());
                const res = await addPayment(user, result);
                dispatch(stopLoading());
                const isError = res.status !== 200;
                setSnackbarState({
                  open: true,
                  message: res.message,
                  severity: isError ? 'error' : 'success'
                });
                if (!isError) {
                  getPayment(user, member._id)
                    .then((res) => {
                      if (res.status === CONSTANTS.STATUS_CODES.FORBIDDEN)
                        dispatch(logoutUser());
                      if (res.status === CONSTANTS.STATUS_CODES.SUCCESS) {
                        dispatch(updatePayments(res.data));
                      }
                      dispatch(stopLoading());
                      setOpen();
                    })
                    .catch((err) => {
                      dispatch(stopLoading());
                      console.log(err);
                    });
                }
              } catch (err) {
                dispatch(stopLoading());
                setSnackbarState({
                  open: true,
                  message: err.message,
                  severity: 'error'
                });
              }
            }}
          >
            {({
              errors,
              handleBlur,
              handleChange,
              handleSubmit,
              setFieldValue,
              isSubmitting,
              touched,
              values
            }) => (
              <PaymentForm
                errors={errors}
                handleBlur={handleBlur}
                handleChange={handleChange}
                handleSubmit={handleSubmit}
                setFieldValue={setFieldValue}
                isSubmitting={isSubmitting}
                touched={touched}
                values={values}
                handleCloseModal={setOpen}
                heading={STRINGS.REGISTER_PAYMENT}
              />
            )}
          </Formik>
        </Container>
      </Modal>
    </>
  );
};

export default RegisterPaymentModal;
